


















import Vue from "vue";
import marked from "marked";

export default Vue.extend({
  props: {
    message: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true,
      validator(value) {
        return ["success", "error"].includes(value);
      }
    }
  },

  data() {
    return {
      closed: false
    };
  },

  computed: {
    isOpen(): boolean {
      return !this.closed && this.hasMessage;
    },

    hasMessage(): boolean {
      return this.message.trim().length > 0;
    },

    colorClasses(): string {
      switch (this.type) {
        case "error":
          return "bg-red-100 border-red-500";
        case "success":
        default:
          return "bg-success-100 border-success-500";
      }
    },

    formattedMessage(): string | null {
      if (!this.hasMessage) {
        return null;
      }

      return marked(this.message);
    }
  }
});
